import * as _abitype2 from "abitype";
var _abitype = _abitype2;
try {
  if ("default" in _abitype2) _abitype = _abitype2.default;
} catch (e) {}
import { dew as _normalizeSignatureDew } from "./normalizeSignature.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getFunctionSignature = void 0;
  const abitype_1 = _abitype;
  const normalizeSignature_js_1 = _normalizeSignatureDew();
  const getFunctionSignature = fn_ => {
    const fn = (() => {
      if (typeof fn_ === "string") return fn_;
      return (0, abitype_1.formatAbiItem)(fn_);
    })();
    return (0, normalizeSignature_js_1.normalizeSignature)(fn);
  };
  exports.getFunctionSignature = getFunctionSignature;
  //# sourceMappingURL=getFunctionSignature.js.map
  return exports;
}